(function () {
  var FeatureFlag,
    GroupAccept,
    makeSlots,
    mountHeader,
    mountPaymentIcon,
    mountReactComponent,
    mountSecuredByQwilrBtn,
    mountTickIcon,
    ref,
    scrollToTop;

  makeSlots = require("./MakeSlots");

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag")["default"];

  mountReactComponent = require("MountReactComponent/MountReactComponent")["default"];

  mountHeader = require("../Utils/InlineAcceptHeader").mountHeader;

  mountSecuredByQwilrBtn = require("../Utils/SecuredByQwilr").mountAcceptFlowSecuredByQwilrBtn;

  scrollToTop = require("../Utils/ScrollToTop").scrollToTop;

  (ref = require("./GroupAcceptReactIcons")),
    (mountPaymentIcon = ref.mountPaymentIcon),
    (mountTickIcon = ref.mountTickIcon);

  module.exports = GroupAccept = (function () {
    function GroupAccept(
      createUi,
      accepters,
      settings,
      invoke,
      acceptData,
      make,
      closeAll,
      getPoweredByQwilr,
      acceptUtils,
      speechBubble,
      usingFeature,
      acceptTelemetry,
      isPrintMode,
    ) {
      var buildAcceptForm,
        buildPaymentForm,
        getQwilrButton,
        hasAnyoneAccepted,
        isUsingInlineForm,
        onClick,
        paymentActive,
        showGroupAccept,
        slots;
      this.viewState = "open";
      slots = invoke(makeSlots, null, {
        accepters: accepters,
      });
      isUsingInlineForm = !usingFeature(FeatureFlag.OptOutNewEditor);
      getQwilrButton = (function (_this) {
        return function () {
          if (isUsingInlineForm) {
            return mountSecuredByQwilrBtn(mountReactComponent(createUi), {});
          } else {
            return getPoweredByQwilr(acceptUtils.utmMedium);
          }
        };
      })(this);
      onClick = (function (_this) {
        return function (slot) {
          acceptData.name = slot.name;
          setTimeout(function () {
            return scrollToTop();
          }, 220);
          return (_this.ui = buildAcceptForm().ui);
        };
      })(this);

      /*
        @NOTE (som, 2020-02-06): we have a bug in our accept flow where, if payment details are
        entered before the first person accepts, the acceptance data is left in a corrupted state
        with missing information. We work around this by not allow payment details to be entered
        if nobody has accepted yet
       */
      hasAnyoneAccepted = function () {
        return accepters.finalisedAccepters.length > 0;
      };
      paymentActive = function () {
        var ref1;
        return (ref1 = settings.payNow) != null ? ref1.enabled : void 0;
      };
      showGroupAccept = (function (_this) {
        return function () {
          return createUi(require("./GroupAccept.html"), {
            slots: slots,
            onClick: function (slot) {
              if (!slot.accepted) {
                return onClick(slot);
              }
            },
            poweredByQwilr: getQwilrButton(),
            showBranding: acceptUtils.showBranding,
            viewState: _this.viewState,
            close: closeAll,
            isComplete: function (slot) {
              return slot.accepted;
            },
            paymentAdded: function () {
              return accepters.paymentAdded;
            },
            paymentActive: paymentActive,
            hasAnyoneAccepted: hasAnyoneAccepted,
            enterPayment: function () {
              if (!hasAnyoneAccepted()) {
                return speechBubble.explain({
                  targetSelector: ".group-accept__payment",
                  message: "Please enter your details before making a payment",
                });
              } else if (!accepters.paymentAdded) {
                return (_this.ui = buildPaymentForm().ui);
              }
            },
            paymentDetailsEnteredAt: new Date(accepters.paymentAddedAt),
            isUsingInlineForm: isUsingInlineForm,
            paymentIcon: mountPaymentIcon(mountReactComponent(createUi)),
            tickIcon: mountTickIcon(mountReactComponent(createUi)),
            $init: function ($scope) {
              return ($scope.ui.inlineHeader = mountHeader(mountReactComponent(createUi), {
                onClose: function () {
                  return $scope.$apply(closeAll);
                },
                screen: "groupAccept",
                telemetry: acceptTelemetry,
              }));
            },
          });
        };
      })(this);
      this.ui = showGroupAccept();

      // if we're in print mode and the flow has been started (i.e. this component is rendered),
      // go straight to the form step
      if (isPrintMode) {
        this.ui = make(require("../SingleAccept/SingleAccept").default, {
          acceptButton: settings.button,
          closeCurrent: function () {
            return (_this.ui = showGroupAccept());
          },
          options: {
            canGoBack: true,
          },
        }).ui;
      }

      buildAcceptForm = (function (_this) {
        return function () {
          return make(require("../SingleAccept/SingleAccept").default, {
            acceptButton: settings.button,
            closeCurrent: function () {
              return (_this.ui = showGroupAccept());
            },
            options: {
              canGoBack: true,
            },
          });
        };
      })(this);
      buildPaymentForm = (function (_this) {
        return function () {
          return make(require("../PayNow/PayNowStep"), {
            closeCurrent: function () {
              return (_this.ui = showGroupAccept());
            },
            payNowSettings: settings.payNow || {},
          });
        };
      })(this);
    }

    return GroupAccept;
  })();
}.call(this));
